import React from "react"
import { Box, type ChakraProps } from "@chakra-ui/react"
import { type ReactNode } from "react"

interface SnapBgInterface {
  position?: "left" | "right"
  children: ReactNode
  chakraProps?: ChakraProps
}
export const SnapBg = ({ position, children, chakraProps }: SnapBgInterface): JSX.Element => {
  return (
    <Box bg="primary" w="100%" p="0" {...chakraProps} minH="100vh">
      {children}
    </Box>
  )
}
